exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay-right{\n    width: 1rem !important;\n\n}\n\nelement.style {\n}\n\n#slider-buttons-left[_ngcontent-c5] {\n    left: 9px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/ecommerce/productlist/productlist.component.css
// module id = ../../../../../src/app/ecommerce/productlist/productlist.component.css
// module chunks = common